import axios from 'axios';
import { ApiService } from '../../../shared/service/Apiservice';
import { environment } from '../../../shared/enviroment/environment';
import { CreateOrderDto, VerifyPaymentDto } from '../dto/Checkout.dto';

export class CheckoutService {
  private apiRootServer = environment.api.apiRootServer;
  private __ApiService: ApiService;

  constructor() {
    const axiosInstance = axios.create();
    this.__ApiService = new ApiService(axiosInstance, this.apiRootServer);
  }
  async createOrder(payload: CreateOrderDto): Promise<any> {
    return this.__ApiService.postRequest('checkout/razorpay/order', payload, {
      apiRoot: this.apiRootServer,
    });
  }
  async verifyPayment(payload: VerifyPaymentDto): Promise<any> {
    return this.__ApiService.postRequest('checkout/razorpay/verify', payload, {
      apiRoot: this.apiRootServer,
    });
  }
  async createOrderRecord(orderPayload: any): Promise<any> {
    return this.__ApiService.postRequest('orders', orderPayload, {
      apiRoot: this.apiRootServer,
    });
  }
}

export default CheckoutService;
